__turbopack_context__.v({
  "leftAlign": "PlantTreeSection-module__KcX4Fa__leftAlign",
  "underlineLink": "PlantTreeSection-module__KcX4Fa__underlineLink",
});
